module.exports = __webpack_public_path__ + "static/media/icon-ekb-card.9b09b4ad58607ec7f49288e2f910e881.svg";